import React, { Component } from 'react'
import Webcam from 'react-webcam'
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {storage} from './Firebase'
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth, firestore } from './Firebase'
import { doc, collection, updateDoc, getDoc, getDocs } from "firebase/firestore"; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios'

export default class FaceVerify extends Component {
  constructor(props){
    super(props);
    this.imageref={}
    this.state = {
      image: null,
      User : '',
    }
  }
  photoCapture =() =>{
    this.setState({
      image: this.imageref.current.getScreenshot()
    })
  }
  resetCapture =() =>{
    this.setState({
      image:null
    })
  }
  GetURL = async (e) => {
    e.preventDefault();
    let user = this.state.User
    const pathReference = await getDownloadURL(ref(storage, `UserVerificationImages/${user}`));
    // console.log(pathReference)
    const path = pathReference
    // console.log(path)
    return path
  }

  UploadURL = async (e)=>{
    e.preventDefault();
    const path = await this.GetURL(e);

    const Users = [];
    const Admins = [];

    const querySnapshot = await getDocs(collection(firestore, "Users"));
    const querySnapshotAdmin = await getDocs(collection(firestore, "Admins"));

    querySnapshot.forEach((doc) => {
      Users.push(doc.data().UserNumber);
    });

    querySnapshotAdmin.forEach((doc) => {
      Admins.push(doc.data().UserNumber);
    });

    let flag = 0, adminFlag = 0 ;
    for (let i = 0; i < Users.length; i++) {
      if(Users[i]=== this.state.User){
        flag = 1;
        break;
      }
    }
    for (let j = 0; j < Admins.length; j++) {
      if(Admins[j]=== this.state.User){
        adminFlag = 1;
        break;
      }
    }

    if(adminFlag===1){
      await updateDoc(doc(firestore, 'Admins', this.state.User), {
        UserVerificationImage : path
      });
      console.log('Url Uploaded')
    }else if(flag===1){
      await updateDoc(doc(firestore, 'Users', this.state.User), {
        UserVerificationImage : path
      });
      console.log('Url Uploaded')
    }
  }

  OnLogin = async (e)=>{
    e.preventDefault();
    await this.getUser(e);
    const imageURL = this.state.image.split(',')[1]
    const byteCharacters = atob(imageURL);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    let imageU = new Blob([byteArray], { type: 'image/jpeg' });
    let user = this.state.User
    const storageRef = ref(storage, `UserVerificationImages/${user}`);
    const metaData = {
      contentType: 'image/jpeg',
    };
    uploadBytes(storageRef, imageU, metaData).then((snapshot) => {
      this.UploadURL(e);
      console.log('Image Uploaded!');
    });
    this.VerifyUserImage()
  }

  getUser = async(e)=>{
    e.preventDefault();
    await onAuthStateChanged(firebaseAuth, (user) => {
      if (user) {
        const number = user.phoneNumber;
        this.setState({
          User : number
        })
      } else {
        console.log('No User')
      }
    });
  }

  VerifyUserImage = async()=>{
    const Users = [];
    const Admins = [];

    const querySnapshot = await getDocs(collection(firestore, "Users"));
    const querySnapshotAdmin = await getDocs(collection(firestore, "Admins"));

    querySnapshot.forEach((doc) => {
      Users.push(doc.data().UserNumber);
    });

    querySnapshotAdmin.forEach((doc) => {
      Admins.push(doc.data().UserNumber);
    });

    let flag = 0, adminFlag = 0 ;
    for (let i = 0; i < Users.length; i++) {
      if(Users[i]=== this.state.User){
        flag = 1;
        break;
      }
    }
    for (let j = 0; j < Admins.length; j++) {
      if(Admins[j]=== this.state.User){
        adminFlag = 1;
        break;
      }
    }
    let ref = '';
    if(adminFlag===1){
      ref = 'Admins'
    }else if(flag===1){
      ref = 'Users'
    }
    const docSnap = await getDoc(doc(firestore, ref, this.state.User));
    const Url1 = docSnap.data().UserProfileImage
    const Url2 = docSnap.data().UserVerificationImage
    console.log(Url1,Url2)
    axios.get('http://192.168.204.105:5000/single',{
      params :{
        url1 : Url1,
        url2 : Url2,
      }
    })
    .then(res=>{
      console.log(res.data)
      if(res.data ==='[True]'){
        alert('User matches with the Database Image')
        if(adminFlag===1){
          window.sessionStorage.setItem('selectedTab', JSON.stringify(5))
          window.location.href='/Dashboard';
        }else if(flag===1){
          window.sessionStorage.setItem('selectedTab', JSON.stringify(5));
          window.location.href='/Voting';
        }
      }else{
        alert('User does not match with the Database Image')
      }
    })
  }

  render() {
    return (
    <>
    <div className='FRS'>
        <div className='Camera'>
          {this.state.image ? 
          <img src={this.state.image} alt='click'></img>
          :<Webcam audio={false} 
          ref={this.imageref}
          screenshotFormat='image/jpeg'/>}
        </div>
        <div className='Cbuttons'>
          <div className='Cbutton1'>
            <button type='submit' onClick={(e)=>this.OnLogin(e)}>LOGIN</button>
          </div>
          <div className='Cbutton2'>
            <button type='submit' onClick={() => this.photoCapture() }>CAPTURE</button>
          </div>
          <div className='Cbutton3'>
            <button type='submit' onClick={() => this.resetCapture() }>RECAPTURE</button>
          </div>
        </div>
    </div>
    </>
    )
  }
}
export function FaceVerifyH (props){
  const navigate = useNavigate()
  return(<FaceVerify navigate={navigate}/>)
}
